const types = {
  FETCH_DOCKET_DATA_START: 'FETCH_DOCKET_DATA_START',
  FETCH_DOCKET_DATA_SUCCESS: 'FETCH_DOCKET_DATA_SUCCESS',
  FETCH_DOCKET_DATA_FAILURE: 'FETCH_DOCKET_DATA_FAILURE',
  FETCH_COLLECTION_ENUMS: 'FETCH_COLLECTION_ENUMS',
  FETCH_COLLECTION_ENUMS_SUCCESS: 'FETCH_COLLECTION_ENUMS_SUCCESS',
  FETCH_SCHEDULED_MAP: 'FETCH_SCHEDULED_MAP',
  FETCH_SCHEDULED_MAP_SUCCESS: 'FETCH_SCHEDULED_MAP_SUCCESS',
  FETCH_COLLECTION_DATA_START: 'FETCH_COLLECTION_DATA_START',
  FETCH_COLLECTION_DATA_SUCCESS: 'FETCH_COLLECTION_DATA_SUCCESS',
  FETCH_SCHEDULED_VEHICLES_START: 'FETCH_SCHEDULED_VEHICLES_START',
  FETCH_SCHEDULED_ITENARY_START: 'FETCH_SCHEDULED_ITENARY_START',
  GET_CURRENT_LOCATION_START: 'GET_CURRENT_LOCATION_START',
  GET_CURRENT_LOCATION_SUCCESS: 'GET_CURRENT_LOCATION_SUCCESS',
  DELETE_INVOICE_START: 'DELETE_INVOICE_START',
  DELETE_INVOICE_SUCCESS: 'DELETE_INVOICE_SUCCESS',
  FETCH_SCHEDULED_ITENARY_SUCCESS: 'FETCH_SCHEDULED_ITENARY_SUCCESS',
  FETCH_SCHEDULED_VEHICLES_SUCCESS: 'FETCH_SCHEDULED_VEHICLES_SUCCESS',
  FETCH_SCHEDULED_COUNT_START: 'FETCH_SCHEDULED_COUNT_START',
  DELETE_DOCKET_START: 'DELETE_DOCKET_START',
  DELETE_DOCKET_SUCCESS: 'DELETE_DOCKET_SUCCESS',
  SAVE_DOCKET_START: 'SAVE_DOCKET_START',
  SAVE_DOCKET_SUCCESS: 'SAVE_DOCKET_SUCCESS',
  SAVE_COLLECTION_START: 'SAVE_COLLECTION_START',
  SAVE_COLLECTION_SUCCESS: 'SAVE_COLLECTION_SUCCESS',
  FETCH_PATH_DETAIL_START: 'FETCH_PATH_DETAIL_START',
  DELETE_TRIP_START: 'DELETE_TRIP_START',
  RESET_SNACKBAR: 'RESET_SNACKBAR',
  DELETE_TRIP_SUCCESS: 'DELETE_TRIP_SUCCESS',
  FIND_CONSIGNEE: 'FIND_CONSIGNEE',
  FIND_CONSIGNEE_SUCCESS: 'FIND_CONSIGNEE_SUCCESS',
  FETCH_FILTERS_START: 'FETCH_FILTERS_START',
  FETCH_FILTERS_SUCCESS: 'FETCH_FILTERS_SUCCESS',
  VALIDATE_ACTION_TIME: 'VALIDATE_ACTION_TIME',
  UPDATE_CONSIGNMENT: 'UPDATE_CONSIGNMENT',
  UPDATE_CONSIGNMENT_SUCCESS: 'UPDATE_CONSIGNMENT_SUCCESS',
  VALIDATE_ACTION_TIME_SUCCESS: 'VALIDATE_ACTION_TIME_SUCCESS',
  FETCH_PATH_DETAIL_SUCCESS: 'FETCH_PATH_DETAIL_SUCCESS',
  FETCH_SCHEDULED_COUNT_SUCCESS: 'FETCH_SCHEDULED_COUNT_SUCCESS',
  RESET_PATH_ITENARY_DATA: 'RESET_PATH_ITENARY_DATA',
};

export default types;
